import Vue from 'vue'
import App from './App.vue'
import router from './router';

import axios from "axios";
import {
  Select,
  Option,
  Switch,
  Slider,
  Tabs,
  TabPane,
  RadioButton,
  RadioGroup,
  Dialog,
  Menu,
  MenuItem,
  Button,
  Loading,
  Image,
  Row,
  Col,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Divider,
} from 'element-ui';

Vue.prototype.$axios = axios;
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;

Vue.use(Select)
Vue.use(Option)
Vue.use(Switch)
Vue.use(Slider)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(RadioButton)
Vue.use(RadioGroup)
Vue.use(Dialog)
Vue.use(Button)
Vue.use(Loading)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Image)
Vue.use(Row)
Vue.use(Col)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Divider)

Vue.config.productionTip = false

new Vue({
  router: router,
  render: h => h(App),
}).$mount('#app')